import { Switch, Route } from "react-router-dom";
import Colaborators from "../Pages/Colaborators";
import Dashboard from "../Pages/Dashboard";
import Guests from "../Pages/Guests";
import Home from "../Pages/Home";
import ProductsAndServices from "../Pages/ProductsAndServices";
import UnitHabits from "../Pages/UnitHabits";
import SpecificHU from "../Pages/SpecificHU";
import PageNotFound from "../Pages/PageNotFound";

import RouteComponent from "./route";
import AboutUs from "../Pages/AboutUs";

const Routes = () => {
  return (
    <Switch>
      <RouteComponent path="/" exact={true} component={Home} isPrivate={false} />
      <RouteComponent
        path="/colaborators"
        exact={true}
        component={Colaborators}
        isPrivate={true}
      />
      <RouteComponent
        path="/dashboard"
        exact={true}
        component={Dashboard}
        isPrivate={true}
      />
      <RouteComponent path="/guests" exact={true} component={Guests} isPrivate={true} />
      <RouteComponent
        path="/products_services"
        exact={true}
        component={ProductsAndServices}
        isPrivate={true}
      />

      <RouteComponent
        path="/unitHabits"
        exact={true}
        component={UnitHabits}
        isPrivate={true}
      />

      <RouteComponent
        path="/unitHabits/:id"
        exact={true}
        component={SpecificHU}
        isPrivate={true}
      />
      <RouteComponent
        path="/about_us"
        exact={true}
        component={AboutUs}
        isPrivate={false}
      />

      <Route
      component={PageNotFound}
       />

    </Switch>
  );
};
export default Routes;
